import moment from "moment";

export const SHORTEST_KEY = '__shortest__';
export const LONGEST_KEY = '__longest__';
export const rowKey = (rowNumber) => `__row_${rowNumber}__`;

const systemFields = () => ({
    'system.datetime': moment().format('DD.MM.YYYY HH:mm:ss'),
    'system.time': moment().format('HH:mm:ss'),
    'system.date': moment().format('DD.MM.YYYY'),
});

const applyFilter = (value, filter) => {
    const integerPadding = String(filter || '').match(/^i(\d+)$/);
    if (integerPadding) {
        return String(value ?? '').padStart(Number(integerPadding[1]), '0');
    }
    return value ?? '';
};

export const replaceWildcards = (text, data) => {
    if (typeof text !== 'string' || text.indexOf('%') === -1) return text;
    const replacements = { ...systemFields(), ...(data || {}) };

    return text.replace(/%([^%]+)%/g, (wildcard, token) => {
        const separator = token.indexOf('|');
        const field = separator === -1 ? token : token.slice(0, separator);
        const filter = separator === -1 ? null : token.slice(separator + 1);
        const value = replacements[field];

        if (value === undefined) return wildcard;
        return filter === null ? (value ?? '') : applyFilter(value, filter);
    });
};

const fieldsFromRow = (keys, row) => {
    const out = {};
    keys.forEach(k => { out[k.name] = row[k.column]; });
    return out;
};

export const buildSyntheticRows = (keys, rows) => {
    const shortest = {};
    const longest = {};
    keys.forEach(k => {
        let minVal = null;
        let maxVal = null;
        rows.forEach(row => {
            const v = row[k.column] == null ? '' : String(row[k.column]);
            if (minVal === null || v.length < minVal.length) minVal = v;
            if (maxVal === null || v.length > maxVal.length) maxVal = v;
        });
        shortest[k.name] = minVal == null ? '' : minVal;
        longest[k.name] = maxVal == null ? '' : maxVal;
    });
    return { shortest, longest };
};

export const buildPreviewOptions = (rows, limit = 4) => {
    const count = Math.min(rows.length, limit);
    const options = [];
    for (let i = 0; i < count; i++) {
        const rowNumber = rows[i].row ?? (i + 1);
        options.push({ label: `Строка ${rowNumber}`, value: rowKey(rowNumber) });
    }
    if (rows.length > 0) {
        options.push({ label: 'Самая короткая', value: SHORTEST_KEY });
        options.push({ label: 'Самая длинная', value: LONGEST_KEY });
    }
    return options;
};

export const buildDataSet = (keys, rows, selectedKey) => {
    const technicalFields = systemFields();
    if (!Array.isArray(rows) || rows.length === 0) return technicalFields;
    const availableKeys = Array.isArray(keys) ? keys : [];

    if (selectedKey === SHORTEST_KEY || selectedKey === LONGEST_KEY) {
        const { shortest, longest } = buildSyntheticRows(availableKeys, rows);
        const fields = selectedKey === SHORTEST_KEY ? shortest : longest;
        return {
            row: '—',
            ...technicalFields,
            ...fields,
        };
    }

    const match = typeof selectedKey === 'string' ? selectedKey.match(/^__row_(\d+)__$/) : null;
    const rowNumber = match ? parseInt(match[1], 10) : (rows[0].row ?? 1);
    const row = rows.find(r => r.row === rowNumber) ?? rows[0];

    return {
        row: row.row,
        ...technicalFields,
        ...fieldsFromRow(availableKeys, row),
    };
};
